import PowerSvg from '@/shared/assets/images/Power.svg'
import { useAppDispatch, useAppSelector } from '@/shared/lib/redux'
import { fetchApiKey, selectApiKey } from '../../model'
import { useUpdateApiKeyModal } from '@/features/update-api-key'

export const UpdateApiKey = () => {
    const { openUpdateApiKeyModal } = useUpdateApiKeyModal()
    const apiKey = useAppSelector(selectApiKey)
    const dispatch = useAppDispatch()

    const onUpdate = () => {
        dispatch(fetchApiKey())
    }

    return (
        <button className={apiKey.enabled ? 'text-color-primary' : 'text-color-danger'} onClick={() => openUpdateApiKeyModal(apiKey, onUpdate)}>
            <PowerSvg width={20} height={20} />
        </button>
    )
}